import React from 'react';
import {Link, Head} from '@inertiajs/inertia-react';
import Text from "@/Components/Front/Text";
import Gad from "@/Components/Front/SVGS/Gad";
import BoxColors from "@/Components/Front/SVGS/BoxColors";
import Close from "@/Components/Front/SVGS/Close";
import Fade from "react-reveal/Fade";
import VisibilitySensor from "react-visibility-sensor";
import {useMediaQuery} from "react-responsive";
import Toggle from "@/Components/Front/Toggle";


const Menu = ({open, active, textProps, setMenuOpen, locale, handleLangChange}) => {

    const [items, setItems] = React.useState([
        {active: false, label: "menu-database-analysis", link: "services-database"},
        {active: false, label: "menu-registry-program-design", link: "services-registry-program-design"},
        {active: false, label: "menu-data-science", link: "services-data-science"},

        {active: false, label: "menu-systematic-reviews", link: "services-systematic-reviews"},
        {active: false, label: "menu-meta-analysis", link: "services-meta-analysis"},
        {
            active: false,
            label: "menu-design-of-observational-protocols",
            link: "services-observational-protocols-design"
        },

    ]);

    const isMobile = useMediaQuery({query: '(max-width: 639px)'});
    const isSm = useMediaQuery({query: '(min-width: 640px)'})


    return (

        <div id={"menu"} className={open ? 'active' : ''}>

            {isMobile &&
                <div className={"mobile-lang-toggle-container"}>

                    <Toggle lang={locale} handleLangChange={handleLangChange}/>

                </div>
            }


            <div className={"box-colors-container"}>
                <BoxColors/>
            </div>

            <div className={"close-container"}>
                {open &&
                    <Fade>

                        <Close onClick={() => {
                            setMenuOpen(false)
                        }}/>
                    </Fade>
                }

            </div>
            <div className={"items-container"}>

                {items.map(i => {
                    return (
                        <div key={i.label} className={active === i.link ? "menu-item active" : 'menu-item'}>
                            <Link href={i.link}>

                                <Text {...textProps} str={i.label}/>
                            </Link>
                        </div>
                    )

                })}

            </div>


        </div>
    )
}

export default Menu;
